import comment from './comment';
import reviewrequest from './reviewrequest';
import task from './task';

export default {
  comment: comment,
  reviewrequest: reviewrequest,
  task: task
};
//# sourceMappingURL=index.js.map


//////////////////
// WEBPACK FOOTER
// ../gipsy-misc/lib/models/index.js
// module id = 630
// module chunks = 0